type DrawPathOptions = {
  fill?: string;
  stroke?: string;
  lineWidth?: number;
  lineCap?: CanvasLineCap;
};

export const drawPath = (
  ctx: CanvasRenderingContext2D,
  path: Path2D,
  { fill, stroke, lineWidth, lineCap }: DrawPathOptions
) => {
  if (fill !== undefined) {
    ctx.fillStyle = fill;
    ctx.fill(path);
  }

  if (stroke !== undefined) {
    ctx.strokeStyle = stroke;

    if (lineWidth !== undefined) {
      ctx.lineWidth = lineWidth;
    }

    if (lineCap !== undefined) {
      ctx.lineCap = lineCap;
    }

    ctx.stroke(path);
  }
};
